export type PaletteColor =
  | 'blue'
  | 'orange'
  | 'red'
  | 'green'
  | 'purple'
  | 'purpur'
  | 'cyan'
  | 'violet'
  | 'brown'
  | 'gray'
  | ''

export type ColorPaletteOption<T extends PaletteColor = PaletteColor> = {
  color: T
  outline: boolean
  gradient?: boolean
}

export const colorPaletteOptions: ColorPaletteOption[] = [
  {
    color: 'orange',
    outline: false,
  },
  {
    color: 'blue',
    outline: false,
  },
  {
    color: 'green',
    outline: false,
  },
  {
    color: 'red',
    outline: false,
  },
  {
    color: 'cyan',
    outline: false,
  },
  {
    color: 'violet',
    outline: false,
  },
  {
    color: 'purpur',
    outline: false,
  },
  {
    color: 'brown',
    outline: false,
  },
  {
    color: 'orange',
    outline: true,
  },
  {
    color: 'blue',
    outline: true,
  },
  {
    color: 'green',
    outline: true,
  },
  {
    color: 'red',
    outline: true,
  },
  {
    color: 'cyan',
    outline: true,
  },
  {
    color: 'violet',
    outline: true,
  },
  {
    color: 'purpur',
    outline: true,
  },
  {
    color: 'brown',
    outline: true,
  },
]

export const colorPaletteOptionsOutline = colorPaletteOptions.filter((el: ColorPaletteOption) => el.outline)
export const colorPaletteOptionsFilled = colorPaletteOptions.filter((el: ColorPaletteOption) => !el.outline)
